module.exports = __webpack_public_path__ + "img/0_Modern.5ad03de0.png";